import React from 'react';
import { useLocation } from 'react-router-dom';

/**
 * BreadcrumbSchema Component
 * Helps Google understand site structure and shows breadcrumbs in search results
 * Critical for improving click-through rates from search
 * 
 * IMPORTANT: Renders inline so Google can see it on first crawl
 */

// Generate breadcrumbs based on URL path
const generateBreadcrumbs = (pathname) => {
  const breadcrumbs = [{ name: 'Home', path: '/' }];
  
  const pathMap = {
    '/services': { name: 'Services', path: '/services' },
    '/services/audio': { name: 'Audio & Podcasting', path: '/services/audio' },
    '/services/video': { name: 'Video & YouTube', path: '/services/video' },
    '/services/publishing': { name: 'Book Publishing', path: '/services/publishing' },
    '/website-mobile': { name: 'Website & Apps', path: '/website-mobile' },
    '/packages': { name: 'Packages', path: '/packages' },
    '/podcasts': { name: 'Podcasts', path: '/podcasts' },
    '/blog': { name: 'Blog', path: '/blog' },
    '/contact': { name: 'Contact', path: '/contact' },
  };

  if (pathname === '/') return breadcrumbs;

  // Handle service pages
  if (pathname.startsWith('/services/')) {
    breadcrumbs.push({ name: 'Services', path: '/services' });
    if (pathMap[pathname]) {
      breadcrumbs.push(pathMap[pathname]);
    }
  } else if (pathMap[pathname]) {
    breadcrumbs.push(pathMap[pathname]);
  }

  return breadcrumbs;
};

const BreadcrumbSchema = ({ items }) => {
  const location = useLocation();
  
  // Default breadcrumbs based on current path if not provided
  const defaultItems = generateBreadcrumbs(location.pathname);
  const breadcrumbItems = items || defaultItems;

  if (!breadcrumbItems || breadcrumbItems.length === 0) return null;

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbItems.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": `https://audioandco.com${item.path}`
    }))
  };

  return (
    <script
      type="application/ld+json"
      data-schema="breadcrumb"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
    />
  );
};

export default BreadcrumbSchema;
